<template>
  <div class="check-work-body">
    <div>
      <div class="search-wrap">
        <el-button size="mini" type="primary" @click="edit()" style="margin-right: 5px;" icon="el-icon-plus">添加</el-button>
        <el-input size="mini" placeholder="请输入类型名称" v-model="where.name" clearable style="width: 200px"></el-input>
        <el-button size="mini" type="primary" @click="search">搜索</el-button>
        <div style="width: 30px;display: inline-block;"></div>
        <el-button type="danger" size="mini" icon="el-icon-delete" v-if="multipleSelection.length" @click="dels()">删除</el-button>
      </div>
      <div class="table-wrap">
        <div style="border-bottom: 1px solid #EBEEF5;margin-bottom: 7px;"></div>
        <el-table v-if="pageData" border v-loading="loading" :data="pageData.list" @selection-change="handleSelectionChange">
          <el-table-column
            type="selection"
            width="55">
          </el-table-column>
          <el-table-column prop="id" label="id" align="center" width="50"></el-table-column>
          <el-table-column prop="name" label="	类型名称" align="center" width="200"></el-table-column>
          <el-table-column prop="expenditure_name" label="费项名称" show-overflow-tooltip></el-table-column>
          <el-table-column prop="status" label="状态" align="center" width="100">
            <template slot-scope="scope">
              {{scope.row.status?'显示':'关闭'}}
            </template>
          </el-table-column>
          <el-table-column prop="create_time" label="创建时间" align="center" width="100"></el-table-column>
          <el-table-column prop="update_time" label="操作时间" align="center" width="100"></el-table-column>
          <el-table-column label="操作 " align="center" width="200">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" icon="el-icon-edit" @click="edit(scope.row)">修改</el-button>
              <el-button type="danger" size="mini" icon="el-icon-delete" @click="del(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div style="margin-top: 20px;text-align: right;margin-right: 20px;">
        <Page :total="pageData.total*1" :current-page="pageData.page*1" :page-size="pageData.pageSize*1" @on-change="pageChange" show-total />
      </div>
    </div>



    <!-- 修改窗口 -->
    <el-dialog title="编辑" :visible.sync="dialogVisible" :close-on-click-modal="false" width="600px">

      <div style="max-height: 500px;overflow-y: auto;">
        <el-form :model="form" ref="form" label-width="100px" size="mini" style="margin-right: 50px;">
          <el-form-item label="类型名称" prop="title">
            <el-input class="form-input" v-model="form.name" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="类型费项" prop="title">
            <el-select size="mini" style="width: 100%" v-model="form.expenditure_ids" filterable multiple placeholder="类型费项" class="kuan">
              <el-option
                v-for="item in house_charge_item_list"
                :key="item.id"
                :label="item.chargeItem_name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="类型状态" prop="title">
            <el-select size="mini" style="width: 100%" v-model="form.status" filterable placeholder="类型状态" class="kuan">
              <el-option
                v-for="item in [{name:'开启',val:1},{name:'关闭',val:0}]"
                :key="item.val"
                :label="item.name"
                :value="item.val">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="类型备注" prop="title">
            <el-input
              type="textarea"
              placeholder="请输入内容"
              v-model="form.remarks"
              maxlength="100"
              show-word-limit
            >
            </el-input>
          </el-form-item>

        </el-form>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button :disabled="form.status>1" type="primary" @click="submitForm('form')" >确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>

export default {
  name:"MeterType",
  data () {
    return {
      host_url:"",
      keyword: '',
      loading: false,
      where:{
        name:""
      },
      pageData:{
        list:[],
        total:0,
        pageSize:15,
        page:1
      },
      dialogVisible:false,
      form:{
        name:"",
        expenditure_ids:[],
        expenditure_name:[],
        status:1,
        remarks:"",
      },
      uploadUrl:"",
      month_value:"",
      business_list:[],
      entry_type_name:"",
      multipleSelection:[],
      house_charge_item_list:[]
    }
  },
  created() {
    this.host_url=__HTTP__.defaults.baseURL;
    // this.month_value=CommonHelp.date("YYYY-MM");
    this.getList()
    this.getHouseChargeItemList()
  },
  watch: {
    dialogVisible(val) {
      if(val == false) {
        // this.fileList = []
      }
    },
    "form.expenditure_ids":{
      deep:true,
      immediate:true,
      handler(n) {
        if(n){
          this.form.expenditure_name=(this.house_charge_item_list.filter(ret=>{ return n.includes(ret.id) })).map(ret=>{ return ret.chargeItem_name })
        }else {
          this.form.expenditure_name=[]
        }

      }
    }
  },
  computed:{

  },
  methods: {
    getFormData(data) {
      return Object.assign({
        id:'',
        name:"",
        expenditure_ids:[],
        expenditure_name:[],
        status:1,
        remarks:"",
      }, data)
    },
    search() {
      this.pageData.page = 1
      this.getList()
    },
    getList() {
      var that=this;
      that.loading=true;
      let where=reObject(this.where);
      ERP.getRequest({
        url:"admin/MeterType/getList",
        data:{
          where:JSON.stringify(where),
          page: this.pageData.page,
          page_size: this.pageData.pageSize
        }
      },res=>{
        if(res.code) {
          res.data.list.map(ret=>{
            ret.expenditure_ids&&( ret.expenditure_ids=ret.expenditure_ids.split(',').map(ret=>{return ret*1}) );
            return ret;
          })
          that.pageData=res.data
        }
        that.loading=false;
        that.multipleSelection=[]
      })
    },
    pageChange(i) {
      this.pageData.page = i
      this.getList()
    },
    edit(item) {
      if(!item) {
        this.form = this.getFormData({})
      } else {
        let data=reObject(item)
        data.bill_type&&(data.bill_type=data.bill_type.split(","))
        this.form = data;
      }
      this.dialogVisible = true
    },

    submitForm(formName) {
      var that=this;
      that.$refs[formName].validate((valid) => {
        if (valid) {
          that.formLoading = true
          let data = Object.assign({}, this.form)
          data.expenditure_name=data.expenditure_name.join(',')
          data.expenditure_ids=data.expenditure_ids.join(',')
          ERP.postRequest({url:"admin/MeterType/save", data:data},res => {
            that.$message({type: res.code === 1 ? 'success': 'error', message: res.msg})
            if(res.code) {
              that.dialogVisible = false
              that.getList()
            }
            that.formLoading = false
          })
        } else {
          return false;
        }
      });
    },

    setFrom(data){
      var that=this;
      ERP.postRequest({url:"admin/MeterType/save", data:data},res => {
        that.$message({type: res.code === 1 ? 'success': 'error', message: res.msg})
        if(res.code) {
          that.getList()
        }
      })
    },
    del(item){
      var that=this;
      ERP.postRequest({
        url:"admin/MeterType/delete",
        data:{
          id:item.id
        }
      },res => {
        that.$message({type: res.code === 1 ? 'success': 'error', message: res.msg})
        if(res.code) {
          that.getList()
        }
      })
    },
    dels(){
      var that=this;
      ERP.postRequest({
        url:"admin/MeterType/delete",
        data:{
          ids:this.multipleSelection.map(ret=>{return ret.id}).join(',')
        }
      },res => {
        that.$message({type: res.code === 1 ? 'success': 'error', message: res.msg})
        if(res.code) {
          that.getList()
        }
      })
    },
    handleSelectionChange(val) {
      console.log(val)
      this.multipleSelection = val;
    },

    getHouseChargeItemList(){
      var that=this;
      let where={};
      ERP.getRequest({
        url:"admin/HouseChargeitemName/getList",
        data:{
          where:JSON.stringify(where),
          field:"id,chargeItem_name",
          page: 1,
          page_size: 200
        }
      },ret=>{
        if(ret.code){
          that.house_charge_item_list=ret.data.list;
        }
      })
    },
    getHouseChargeList(){
      var that=this;
      let where={};
      this.dow_form.project_house_id&&(where.pindex_id=this.dow_form.project_house_id);
      this.dow_form.chargeItem_name_id&&(where.chargeItem_name_id=this.dow_form.chargeItem_name_id);
      ERP.getRequest({
        url:"admin/HouseCharge/getList",
        data:{
          where:JSON.stringify(where),
          page: 1,
          page_size: 200
        }
      },ret=>{
        if(ret.code){
          that.house_charge_list=ret.data.list;
        }
      })
    },
  }
}
function reObject(item){
  return JSON.parse(JSON.stringify(item));
}
</script>
<style lang="scss" scoped>

.el-button--primary, .el-button--danger ,.el-button--success,.el-button--warning{
  color: #fff;
}


.check-work-body {
  padding: 15px;
  width: 98%;
}

.search-wrap {
  padding-bottom: 7px;
}

.table-wrap {
  margin-top: 7px;
  //height: calc(70vh) !important;
  //overflow: auto !important;
}

.pagination-wrap {
  display: flex;
  justify-content: center;
  margin-top: 15px;
}


.check-work-tb {
  border-collapse: collapse;

  td, th {
    border: 1px solid #EBEEF5;
    line-height: 20px;
    padding: 10px 10px;
    font-size: 12px;
  }

  th {
    font-weight: bold;
    text-align: left;
  }
}

.el-calendar-table .el-calendar-day {
  height: 50px;
}

.check-work-class-editor {
  margin-top: 10px;
  width: 100%;

  .cw-header {
    width: 100%;
    display: table;
    border-collapse: collapse;

    .cw-title {
      display: table-cell;
      border: 1px solid #EBEEF5;
      padding: 5px 10px;
      line-height: 20px;
      font-weight: bold;

      &.cw-name {
        width: 100px;
      }

      &.cw-class {
        flex: 1;
      }
    }

  }

}


.form-input {
  width: 300px;
}
.table-wrap{
  width: calc( 100vw - 180px );
  overflow-x:hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Meter/MeterType.vue